<template>
  <!-- 美丽平罗·数字产业·数字治理·数字服务 -->
  <div>
    <div class="footer_border">
      <div class="f_cont_border">
        <div
          ref="beautyPingluo"
          :class="
            selected == 1
              ? 'foot_cont color1 beautyPingluo'
              : 'foot_cont color beautyPingluo'
          "
          @click="beautifulPL_clickitem('0', '全部')"
          @mouseover="move_pingluo"
          @mouseleave="leave_pingluo"
        >
          美丽平罗
        </div>
      </div>
      <div class="f_cont_border">
        <div
          ref="Numchanye"
          @mouseover="move_chanye"
          @mouseleave="leave_chanye"
          :class="
            selected == 2
              ? 'foot_cont color1 Numchanye'
              : 'foot_cont color Numchanye'
          "
        >
          数字农业
        </div>
        <!-- 数字产业二级导航 -->
        <div
          class="foot_one"
          ref="foot_two"
          @mouseover="move_chanye_first"
          @mouseleave="leave_chanye_first"
        >
          <el-radio-group v-model="radio1">
            <el-radio
              @click.native.prevent="
                digitalIndustrial_clickitem(index, item.name)
              "
              :label="index"
              v-for="(item, index) in digitalIndustrial_checkList"
              :key="index"
              >{{ item.name }}</el-radio
            >
          </el-radio-group>
        </div>
      </div>
      <div class="f_cont_border">
        <div
          ref="NumFuwu"
          @mouseover="move_fuwu"
          @mouseleave="leave_fuwu"
          :class="
            selected == 3
              ? 'foot_cont color1 NumFuwu'
              : 'foot_cont color NumFuwu'
          "
        >
          数字服务
        </div>
        <!-- 数字服务二级导航 -->
        <div
          class="foot_three"
          ref="foot_three"
          @mouseover="move_fuwu_first"
          @mouseleave="leave_fuwu_first"
          style="top: -200px"
        >
          <el-radio-group v-model="radio2" class="text_left">
                    <el-radio
              @click.native.prevent="digitalServer_clickitem(index, item.name)"
              :label="index"
              v-for="(item, index) in digitalServer_checkList"
              :key="index"
            >
              <i
                class="iconfont margin_r"
                v-html="item.icon"
                :class="item.colors"
              ></i
              ><span :class="item.margin">{{ item.name }}</span></el-radio
            >
          </el-radio-group>
        </div>
      </div>
      <div class="f_cont_border">
        <div
          ref="NumZhili"
          @mouseover="move_zhili"
          @mouseleave="leave_zhili"
          :class="
            selected == 4
              ? 'foot_cont color1 NumZhili'
              : 'foot_cont color NumZhili'
          "
        >
          数字治理
        </div>
        <!-- 数字治理二级导航 -->
        <div
          class="foot_four"
          ref="foot_four"
          @mouseover="move_zhili_first"
          @mouseleave="leave_zhili_first"
          style="top: -200px"
        >
          <el-radio-group v-model="radio3" class="text_left">
                    <el-radio
              @click.native.prevent="digitalManage_clickitem(index, item.name)"
              :label="index"
              v-for="(item, index) in digitalManage_checkList"
              :key="index"
            >
              <i
                class="iconfont margin_r"
                v-html="item.icon"
                :class="item.colors"
              ></i
              ><span :class="item.margin">{{ item.name }}</span></el-radio
            >
          </el-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bus from "../utils/beautifulPlBus.js";
export default {
  name: "footer_border",
  components: {},
  data() {
    return {
      digitalIndustrial_checkList: [
        {
          name: "土地资源",
        },
        {
          name: "农业规划",
        },
        {
          name: "作物分布",
        },
        {
          name: "设施农业",
        },
      ],
      beautifulPL_checkList: [
        {
          name: "全部",
        },
        {
          name: "景区",
        },
        {
          name: "村镇",
        },
        {
          name: "产业",
        },
        {
          name: "其他",
        },
      ],
      digitalServer_checkList: [
        {
          margin: "margin_l",
          name: "全部",
        },
        {
          colors: "green",
          icon: "&#xe6d9;",
          name: "农业投入品服务",
        },
        {
          colors: "less_blue",
          icon: "&#xe6d9;",
          name: "农机具服务",
        },
        {
          colors: "lilac",
          icon: "&#xe6d9;",
          name: "农业保险",
        },
        {
          colors: "yellow",
          icon: "&#xe6d9;",
          name: "农业金融",
        },
        {
          colors: "red",
          icon: "&#xe6d9;",
          name: "卫生机构",
        },
        {
          colors: "less_cyan",
          icon: "&#xe6d9;",
          name: "农村电商",
        },
      ],
      digitalManage_checkList: [
        {
          margin: "margin_l",
          name: "全部",
        },
        {
          colors: "less_blue",
          icon: "&#xe6d9;",
          name: "平安乡村",
        },
        {
          colors: "less_acid",
          icon: "&#xe6d9;",
          name: "积分超市",
        },
        {
          colors: "less_brown",
          icon: "&#xe6d9;",
          name: "乡村大喇叭",
        },
        {
          colors: "lilac",
          icon: "&#xe6d9;",
          name: "村/居委会",
        },
        {
          colors: "red",
          icon: "&#xe6d9;",
          name: "派出所",
        },
        {
          colors: "yellow",
          icon: "&#xe6d9;",
          name: "信息员",
        },
      ],
      radio: 0,
      radio1: "",
      radio2: "",
      radio3: "",
      selected: 1,
      change: false,
      change_cont: false,
      change_cont_three: false,
      change_cont_two: false,
      chanage_one: true,
      change_two: true,
      change_three: true,
      name: "",
    };
  },
  methods: {
    beautifulPL_clickitem(e, name) {
      // 删除层级显示
      $("#level").remove();
      $("#init_Level").remove();
      this.map_change = false;
      e === this.radio ? (this.radio = "") : (this.radio = e);
      bus.$emit("beautifulPlBusId", 0);
      if (e === "") {
        // 美丽平罗球体清除
        Anngs.clearItems();
      } else {
        var json = plDataInterface.beautifuPL_AddLayer(e);
        this.beautifulData = plDataInterface.beautifuPL_AddLayer(e);
        plDataInterface.beautifuPL_RemoveLayer();
        // //美丽平罗球体
        Anngs.updateItems(json);
        // // 清除其它选中
        this.radio1 = "";
        this.radio2 = "";
        this.radio3 = "";
        this.selected = 1;
        this.$refs.Numchanye.style.color = "#ffffff";
        this.$refs.NumFuwu.style.color = "#ffffff";
        this.$refs.NumZhili.style.color = "#ffffff";
        plDataInterface.digitalManage_RemoveLayer();
        plMap.removeDigitalIndustrial_TilesLayer();
        plDataInterface.digitalServer_RemoveLayer();
        this.$emit("switchs", true);
        this.$emit("setAtter", false);
        this.$emit("map_change", false);
      }
    },
    digitalIndustrial_clickitem(e, name) {
      this.$emit("map_change", true);
      e === this.radio1 ? (this.radio1 = "") : (this.radio1 = e);
      if (this.radio1 === "") {
        plMap.removeDigitalIndustrial_TilesLayer();
        removeCurEntities();
      } else {
        plMap.addDigitalIndustrial_TilesLayer(e);
        this.radio = "";
        this.radio2 = "";
        this.radio3 = "";
        this.selected = 2;
        this.$refs.beautyPingluo.style.color = "#ffffff";
        this.$refs.NumFuwu.style.color = "#ffffff";
        this.$refs.NumZhili.style.color = "#ffffff";
        Anngs.clearItems();
        plDataInterface.digitalManage_RemoveLayer();
        plDataInterface.digitalServer_RemoveLayer();
        plMap.removeCurEntities();
        // 传值父组件
        this.$emit("switchs", false);
      }
      if (this.radio1 === "") {
        name = false;
      }
      this.$emit("setAtter", name);
    },
    digitalServer_clickitem(e, name) {
      this.$emit("map_change", true);
      plMap.plClearPopupInfo();
      e === this.radio2 ? (this.radio2 = "") : (this.radio2 = e);
      if (this.radio2 === "") {
        plDataInterface.digitalServer_RemoveLayer();
      } else {
        plDataInterface.digitalServer_AddLayer(e);
        this.radio1 = "";
        this.radio = "";
        this.radio3 = "";
        this.selected = 3;
        this.$refs.beautyPingluo.style.color = "#ffffff";
        this.$refs.Numchanye.style.color = "#ffffff";
        this.$refs.NumZhili.style.color = "#ffffff";
        Anngs.clearItems();
        plDataInterface.digitalManage_RemoveLayer();
        plMap.removeDigitalIndustrial_TilesLayer();
        this.$emit("switchs", false);
        this.$emit("setAtter", name);
      }
    },
    digitalManage_clickitem(e, name) {
      this.$emit("map_change", true);
      plMap.plClearPopupInfo();
      e === this.radio3 ? (this.radio3 = "") : (this.radio3 = e);
      if (this.radio3 === "") {
        plDataInterface.digitalManage_RemoveLayer();
      } else {
        plDataInterface.digitalManage_AddLayer(e);

        this.radio1 = "";
        this.radio2 = "";
        this.radio = "";
        this.selected = 4;
        this.$refs.beautyPingluo.style.color = "#ffffff";
        this.$refs.Numchanye.style.color = "#ffffff";
        this.$refs.NumFuwu.style.color = "#ffffff";
        Anngs.clearItems();
        plMap.removeDigitalIndustrial_TilesLayer();
        plDataInterface.digitalServer_RemoveLayer();
        this.$emit("switchs", false);
        this.$emit("setAtter", false);
      }
    },
    move_pingluo() {
      this.foot_one_change = true;
      if (this.selected != 1) {
        this.$refs.beautyPingluo.style.color = "#3EF89C";
      }
    },
    leave_pingluo() {
      if (this.selected != 1) {
        this.$refs.beautyPingluo.style.color = "#ffffff";
      }
    },
    move_chanye() {
      this.$refs.foot_two.style.display = "block";
      if (this.selected != 2) {
        this.$refs.Numchanye.style.color = "#3EF89C";
      }
    },
    move_chanye_first() {
      this.$refs.foot_two.style.display = "block";
      if (this.selected != 2) {
        this.$refs.Numchanye.style.color = "#3EF89C";
      }
    },
    leave_chanye_first() {
      this.$refs.foot_two.style.display = "none";
      if (this.selected != 2) {
        this.$refs.Numchanye.style.color = "#ffffff";
      }
    },
    leave_chanye() {
      this.$refs.foot_two.style.display = "none";
      if (this.selected != 2) {
        this.$refs.Numchanye.style.color = "#ffffff";
      }
    },
    move_fuwu() {
      this.$refs.foot_three.style.display = "block";
      if (this.selected != 3) {
        this.$refs.NumFuwu.style.color = "#3EF89C";
      }
    },
    move_fuwu_first() {
      this.$refs.foot_three.style.display = "block";
      if (this.selected != 3) {
        this.$refs.NumFuwu.style.color = "#3EF89C";
      }
    },
    leave_fuwu() {
      this.$refs.foot_three.style.display = "none";
      if (this.selected != 3) {
        this.$refs.NumFuwu.style.color = "#ffffff";
      }
    },
    leave_fuwu_first() {
      this.$refs.foot_three.style.display = "none";
      if (this.selected != 3) {
        this.$refs.NumFuwu.style.color = "#ffffff";
      }
    },
    move_zhili() {
      this.$refs.foot_four.style.display = "block";
      if (this.selected != 4) {
        this.$refs.NumZhili.style.color = "#3EF89C";
      }
    },
    move_zhili_first() {
      this.$refs.foot_four.style.display = "block";
      if (this.selected != 4) {
        this.$refs.NumZhili.style.color = "#3EF89C";
      }
    },
    leave_zhili() {
      this.$refs.foot_four.style.display = "none";
      if (this.selected != 4) {
        this.$refs.NumZhili.style.color = "#ffffff";
      }
    },
    leave_zhili_first() {
      this.$refs.foot_four.style.display = "none";
      if (this.selected != 4) {
        this.$refs.NumZhili.style.color = "#ffffff";
      }
    },
  },
  mounted() {
    var json = plDataInterface.beautifuPL_AddLayer(0);
    plDataInterface.beautifuPL_RemoveLayer();
    Anngs.updateItems(json);
    bus.$emit("beautifulPlBusId", 0);
    this.$emit("switchs", true);
  },
};
</script>

<style lang='less' scoped>
.footer_border {
  display: flex;
  font-size: 1.5rem;
  /* z-index: -100; */
}
.foot_one,
.foot_two,
.foot_three,
.foot_four {
  width: 13.875rem;
  padding: 0.3125rem 0;
  margin-left: 0.3125rem;
  line-height: 1.5rem;
  background: rgb(21, 96, 110);
  position: absolute;
  z-index: -2;
  font-size: 0.7rem;
  border: 1px solid;
  display: none;
  border: 1px solid rgb(42, 252, 255);
  border-bottom: none;
}
.foot_one,
.foot_two {
  text-align: center;
  top: -119px;
}
.foot_three,
.foot_four {
  top: -10.75rem;
}
.foot_cont {
  width: 13.875rem;
  height: 3.125rem;
  text-align: center;
  line-height: 3.125rem;
  background: url("../assets/images/foot_logo.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin: 0 0.3125rem;
}
.color {
  color: #ffffff;
  text-shadow: 0 0 10px #ffffff;
}
.color1 {
  color: #3ef89c;
  text-shadow: 0 0 10px #ffffff;
}
P {
  margin-block-start: 0em;
  margin-block-end: 0em;
}
.change,
.change_one,
.change_two,
.change_three {
  background: rgb(62, 248, 156);
}
.change_cont,
.change_cont_one,
.change_cont_two,
.change_cont_three {
  color: rgb(62, 248, 156);
}
.f_nav_font {
  cursor: pointer;
}
.f_nav_font {
  display: inline-block;
}
.f_cont_border {
  position: relative;
  cursor: pointer;
}
.text_a_left {
  text-align: left;
}
.text_a_right {
  text-align: right;
}
/deep/.el-radio {
  margin-top: 10px;
  color: #ffffff;
  display: block;
  margin-right: 0;
  &::after {
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
}
/deep/.el-radio__inner {
  width: 15px;
  height: 15px;
  margin-left: 10px;
  border-radius: 0;
}
/deep/.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled)
  .el-radio__inner {
  box-shadow: none;
}
/deep/.el-radio__inner::after {
  width: 0;
  height: 0;
}
/deep/.el-cascader-node > .el-radio,
.el-radio:last-child {
  margin-right: 30px;
}
.text_left {
  text-align: left;
  padding-left: 10px;
}
/deep/.el-radio__label {
  float: left;
}
/deep/.el-radio__input {
  float: right;
}
/deep/.el-cascader-node > .el-radio,
.el-radio:last-child {
  margin-right: 0;
}
/deep/ .el-radio:after {
  clear: both;
  display: block;
  content: "";
}
.z_index {
  z-index: 999;
}
.green {
  color: #09f03b;
}
.less_blue {
  color: #14c4e4;
}
.less_acid {
  color: #ffc68f;
}
.less_brown {
  color: #f18125d2;
}
.lilac {
  color: #f512e9;
}
.yellow {
  color: #faf606;
}
.less_cyan {
  color: rgb(6, 236, 221);
}
.pink {
  color: pink;
}
.red {
  color: red;
}
.margin_r {
  margin-right: 10px;
}
.margin_l {
  margin-left: 27px;
}
/deep/.el-radio__input.is-checked + .el-radio__label {
  color: #3ef89c;
}
/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: #ffffff;
  background: #3ef89c;
}
</style>


// WEBPACK FOOTER //
// src/components/footers.vue